var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 721,
    height: 437,
    viewBox: "0 0 721 437",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.0441 432.945C82.8429 433.35 82.1992 434.208 81.2335 434.403C81.1329 434.97 80.6904 436.103 79.7247 436.103H38.384C37.4184 436.103 36.9758 434.97 36.8752 434.403C35.9096 434.208 35.2658 433.35 35.0647 432.945H83.0441Z",
    fill: "#FFCBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M684.623 432.945C684.422 433.35 683.778 434.208 682.813 434.403C682.712 434.97 682.269 436.103 681.304 436.103H639.963C638.997 436.103 638.555 434.97 638.454 434.403C637.489 434.208 636.845 433.35 636.644 432.945H684.623Z",
    fill: "#FFCBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M720.012 417.154V415.262H0.0115356V417.154C0.0115356 422.681 0.0115356 425.445 1.56039 427.557C2.9228 429.414 5.09672 430.924 7.77063 431.87C10.8104 432.946 14.7897 432.946 22.7484 432.946H697.275C705.233 432.946 709.213 432.946 712.252 431.87C714.926 430.924 717.1 429.414 718.463 427.557C720.012 425.445 720.012 422.681 720.012 417.154Z",
    fill: "url(#paint0_linear_172_3419)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.273 415.262H424.746C424.746 420.145 420.788 424.104 415.904 424.104H304.115C299.232 424.104 295.273 420.145 295.273 415.262Z",
    fill: "url(#paint1_linear_172_3419)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M661.59 17.2932C661.59 7.74241 653.848 0 644.297 0H76.3569C66.8062 0 59.0638 7.74242 59.0638 17.2932L59.0638 402.631C59.0638 406.421 59.6954 415.263 63.8006 415.263H656.853C660.958 415.263 661.59 406.421 661.59 402.631V17.2932Z",
    fill: "url(#paint2_linear_172_3419)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9467 12.3145V385.893H647.684V12.3145H396.985C396.15 12.3145 395.474 12.9911 395.474 13.8258V21.9233C395.474 23.5927 394.12 24.946 392.451 24.946H328.495C326.826 24.946 325.473 23.5927 325.473 21.9233V13.8258C325.473 12.9911 324.796 12.3145 323.961 12.3145H72.9467Z",
    fill: "#FFFCFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_3419",
    x1: 360.012,
    y1: 432.946,
    x2: 360.012,
    y2: 415.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_172_3419",
    x1: 360.01,
    y1: 424.104,
    x2: 360.01,
    y2: 415.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFEBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBCA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_172_3419",
    x1: 360.327,
    y1: 0,
    x2: 360.327,
    y2: 415.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCBBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.11a34211c33b790204755684a16d85ee.svg";
export { ForwardRef as ReactComponent };